import ConditionFilter from './ConditionFilter'
import SelectRow from './SelectRow'
import CourseDetail from './CourseDetail'
import DisContent from './DisContent'
import CourseCard from './CourseCard'
import NavigationBread from './NavigationBread'

export default {
  ConditionFilter,
  SelectRow,
  CourseDetail,
  DisContent,
  CourseCard,
  NavigationBread
}



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/index.js